/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharedplan_YoursInputs */

const en_us2_sharedplan_yours = /** @type {(inputs: Sharedplan_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is a plan you shared.`)
};

const pt_br2_sharedplan_yours = /** @type {(inputs: Sharedplan_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este é um plano que você compartilhou.`)
};

const pt_pt2_sharedplan_yours = /** @type {(inputs: Sharedplan_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este é um plano que você compartilhou.`)
};

/** @type {(inputs: Sharedplan_YoursInputs) => LocalizedString} */
const es_419_sharedplan_yours = en_us2_sharedplan_yours;

/** @type {(inputs: Sharedplan_YoursInputs) => LocalizedString} */
const fr_fr2_sharedplan_yours = en_us2_sharedplan_yours;

/** @type {(inputs: Sharedplan_YoursInputs) => LocalizedString} */
const de_de2_sharedplan_yours = en_us2_sharedplan_yours;

/** @type {(inputs: Sharedplan_YoursInputs) => LocalizedString} */
const it_it2_sharedplan_yours = en_us2_sharedplan_yours;

/**
* | output |
* | --- |
* | "This is a plan you shared." |
*
* @param {Sharedplan_YoursInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const sharedplan_yours = /** @type {((inputs?: Sharedplan_YoursInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharedplan_YoursInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_sharedplan_yours(inputs)
	if (locale === "es-419") return es_419_sharedplan_yours(inputs)
	if (locale === "pt-PT") return pt_pt2_sharedplan_yours(inputs)
	if (locale === "fr-FR") return fr_fr2_sharedplan_yours(inputs)
	if (locale === "de-DE") return de_de2_sharedplan_yours(inputs)
	if (locale === "it-IT") return it_it2_sharedplan_yours(inputs)
	return en_us2_sharedplan_yours(inputs)
});
export { sharedplan_yours as "sharedplan.yours" }